import { rethrowError } from 'UIComponents/core/PromiseHandlers';
import userInfo, { userInfoSync } from 'hub-http/userInfo';
import { useEffect, useState } from 'react';
const useUserInfo = () => {
  const [auth, setAuth] = useState(() => {
    try {
      // Attempt to get user info from cache if already loaded
      return userInfoSync();
    } catch (_unused) {
      return undefined;
    }
  });
  useEffect(() => {
    if (!auth) {
      userInfo().then(retrievedAuth => {
        setAuth(retrievedAuth);
      }).catch(rethrowError);
    }
  }, [auth]);
  return auth;
};
export default useUserInfo;